<template>
  <transition name="list" tag="p">
    <p class="badge-text">
      <a-badge :status="preparePingStatus(ping)"></a-badge>
      <strong>{{ name }}: </strong>{{
        preparePingValue(ping)
      }}
    </p>
  </transition>
</template>

<script>
export default {
  props: {
    name: String,
    ping: Number
  },
  methods: {
    preparePingValue(ping) {
      if (ping == null) {
        return "- brak -"
      } else {
        return `${ping.toFixed(3)} ms`
      }
    },
    preparePingStatus(ping) {
      if (ping == null) {
        return 'error';
      } else if (ping < 50) {
        return 'success'
      } else {
        return 'warning'
      }
    }
  }
};
</script>

<style scoped>
.badge-text {
  margin: 0px;
  padding: 0px;
  font-size: 0.8em;
  line-height: 1.46em;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease-in-out;
  height: 12px;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  height: 0;
}
</style>